export default __webpack_public_path__ + "static/media/staff.e78bee69.jpg";